import { FilePathUtils } from '@/config';

const assetUrl = FilePathUtils.images();

export const fallbackImages = {
  course: '/Images/placeholder/course-placeholder.avif',
  courseCertificate: `${assetUrl}/course-certificate.jpg`,
  textureBackground: `${assetUrl}/texture-background.png`,
  medal: `${assetUrl}/medal.svg`,
  medal2: `${assetUrl}/support-instructor-icon.svg`,
  ellipse: `${assetUrl}/ellipse.svg`,
  user: '/Images/user-fallback.svg',
  courseDetailsBackground: `${assetUrl}/course-details-bg.jpg`,
};
